function decimalToHex(decimal: number) {
  return ('0' + decimal.toString(16)).substr(-2);
}

export function generateCodeVerifier() {
  const array = new Uint32Array(64);
  window.crypto.getRandomValues(array);
  const combined = Array.from(array, decimalToHex).join('');
  return encodeURIComponent(combined).slice(0, 128);
}

export async function generateCodeChallenge(codeVerifier: string) {
  const buffer = new TextEncoder().encode(codeVerifier);
  const digested = await window.crypto.subtle.digest('SHA-256', buffer);
  const hash = String.fromCharCode.apply(null, new Uint8Array(digested));
  return btoa(hash).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
